/** Looping kitchen alert when a new pending order arrives. */
export function playNewOrderAlert() {
  try {
    const AudioCtx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!AudioCtx) return;

    const ctx = new AudioCtx();
    const playBeep = (startAt: number, freq: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.value = 0.28;
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(startAt);
      osc.stop(startAt + 0.2);
    };

    const now = ctx.currentTime;
    for (let i = 0; i < 8; i++) {
      const t = now + i * 0.45;
      playBeep(t, 880);
      playBeep(t + 0.22, 1175);
    }

    window.setTimeout(() => {
      void ctx.close();
    }, 4500);
  } catch {
    /* audio optional */
  }
}
